import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const ThankYou = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Sponsor/partner logos
  const sponsors = [
    { name: "Sketched Impressions", logo: "https://customer-assets.emergentagent.com/job_youth-impact-3/artifacts/a9fzsiso_Sketched%20Impressions%20Logo.png" },
    { name: "Normandy Schools Collaborative", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/2cy4md2h_IMG_0050.PNG" },
    { name: "Mission: St. Louis", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/v45gugaj_IMG_0049.JPG" },
    { name: "Clayco", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/2o03k48i_IMG_0051.JPG" },
    { name: "Goodwill", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/ywb3kc4f_IMG_0047.JPG" },
    { name: "UMB Bank", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/rkcrefaw_IMG_0048.PNG" },
    { name: "Delux", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/sx2blv18_delux.png" },
    { name: "Phat Budda", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/w3k8omz8_PHAT%20BUDDA.png" },
    { name: "ARCHS", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/0msxk3q3_Arches.jpg" },
    { name: "Urban Harvest STL", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/8jcp6j82_pc_food-roof-farm-rainscaping-grant_uhstl-logo_300x300_01.jpg" },
    { name: "Streetz 105.1", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/777xla0g_Streetz%20105.png" },
    { name: "A.S.A.P. - After School for All Partnership", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/9mpy51y7_Asap.png" },
    { name: "Fathers' Support Center St. Louis", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/uyro4q1g_fathers-support-center-st-louis.jpg" },
    { name: "City of St. Louis", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/enm0evoi_City-of-St-Louis-seal.png" },
    { name: "ABC 30 KDNL-TV St. Louis", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/fgrm6bdu_KDNL-TV_Logo.png" },
    { name: "Beloved Streets of America", logo: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/hqon8xrc_beloved_logo.png" },
  ];

  // Photos for the gallery - Through the Years
  const photos = [
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/escyhtt7_Photo%20Sep%2023%2C%206%2059%2053%20PM.jpg", alt: "MiM scholars in classroom holding photos" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/certrpxs_Photo%20Jul%2018%2C%209%2055%2038%20AM.jpg", alt: "MiM scholars in recording studio" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/qqb9ndiy_MIM%201.jpg", alt: "MiM scholars dressed professionally" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/3gbhtiuz_MIM%206.jpg", alt: "MiM scholars at Gateway MST Middle School" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/r4q7jy20_mnm%20slu%20pop%20up%20-378.jpg", alt: "MiM scholars at red carpet event" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/qbknfjvv_mnm%20mission%20pix-579.jpg", alt: "MiM scholar smiling" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/6binp3p0_mnm%20mission%20pix-551.jpg", alt: "MiM scholars with headphones" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/qxf4rx64_mnm%20mission%20pix-465.jpg", alt: "MiM mentors teaching scholars" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/9k0qi7fn_Screenshot%202025-07-16%20at%209.33.48%E2%80%AFAM%202.png", alt: "MiM program moment" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/ya74j5cj_Screenshot%202025-07-16%20at%209.36.38%E2%80%AFAM%202.png", alt: "MiM program moment" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/buk47td9_Photo%20Nov%2020%202025%2C%2012%2031%2037%20PM.jpg", alt: "MiM scholars in hands-on learning activity" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/c5nrrteq_Photo%20Oct%2020%202025%2C%201%2048%2020%20PM.jpg", alt: "MiM scholars in podcasting session" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/yfmihgs0_Photo%20Sep%2023%202025%2C%2012%2037%2003%20PM.jpg", alt: "MiM scholars using heat press for apparel design" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/5yxn9wsb_Photo%20Nov%2020%202025%2C%2012%2023%2024%20PM.jpg", alt: "MiM cosmetology class instruction" },
    { src: "https://customer-assets.emergentagent.com/job_0b676179-5cd1-44f5-bdb2-b528e519da7d/artifacts/6vajemg3_Photo%20Sep%2023%202025%2C%2012%2030%2047%20PM.jpg", alt: "MiM scholar creating custom t-shirt" },
  ];

  return (
    <div>
      <SEO 
        title="Thank You - Our Sponsors & Partners"
        description="Thank you to our generous sponsors and partners who make Mentors in Motion's youth programs possible. See our community supporters and photo gallery."
        keywords="mentors in motion sponsors, nonprofit partners St. Louis, youth program supporters, community partners"
        canonicalUrl="/thank-you"
      />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gray-900 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,rgba(227,27,35,0.3),transparent_50%)]" />
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-2xl sm:text-3xl font-bold text-white mb-6">
              Thank You
            </h1>
            <p className="text-base text-gray-300 leading-relaxed">
              To all of our sponsors, partners, donors, volunteers, and supporters who believe in our mission and invest in the future of St. Louis youth, thank you. Your generosity makes it possible for our scholars to get the tutoring, mentoring, and creative opportunities they deserve. Because of you, young people are gaining skills, confidence, and hope for a brighter future for themselves and their communities.
            </p>
          </div>
        </div>
      </section>

      {/* Heartfelt Message Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <Heart className="w-16 h-16 text-red-500 mx-auto mb-6" />
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">
              From the Bottom of Our Hearts
            </h2>
          </div>
          
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
            <p>
              Since 2009, Mentors in Motion has been blessed with an incredible community of supporters who share our belief that every young person deserves the chance to discover their potential and build a brighter future.
            </p>
            
            <p>
              To our sponsors and partners, past and present: your generosity has made it possible for thousands of scholars to receive tutoring, mentoring, and creative learning experiences that have transformed their academic journeys and their lives. Because of you, young people who were once struggling are now thriving. Students who couldn't see a path forward are now dreaming of college, careers, and entrepreneurship.
            </p>
            
            <p>
              To our volunteers and mentors: you have given something that money cannot buy, your time, your wisdom, and your belief in our scholars. The relationships you've built have shown young people that they matter, that someone cares, and that their futures are worth investing in.
            </p>
            
            <p>
              To the families who have trusted us with your children: thank you for partnering with us. Together, we are building a generation of confident, capable young leaders who will strengthen our communities for years to come.
            </p>
            
            <p className="text-xl font-semibold text-red-600 text-center">
              Every dollar donated, every hour volunteered, every word of encouragement shared has made a difference. We are deeply grateful for each and every one of you.
            </p>
            
            <p className="text-center">
              With heartfelt appreciation,<br />
              <strong>The Mentors in Motion Family</strong>
            </p>
          </div>
        </div>
      </section>

      {/* Sponsors & Partners Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-sm font-semibold text-red-600 uppercase tracking-wider mb-3">
              Our Supporters
            </h2>
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Sponsors & Partners
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We are honored to work alongside these organizations and individuals who make our mission possible.
            </p>
          </div>

          {/* Logo Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center">
            {sponsors.map((sponsor, index) => (
              <div 
                key={index} 
                className={`bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow flex items-center justify-center overflow-hidden ${sponsor.name === 'Sketched Impressions' ? 'p-0 h-48' : 'p-8 h-40'}`}
              >
                {sponsor.logo ? (
                  <img 
                    src={sponsor.logo} 
                    alt={sponsor.name} 
                    className={`object-contain ${sponsor.name === 'Sketched Impressions' ? 'h-48 w-full scale-150' : 'max-h-28 max-w-full'}`}
                  />
                ) : (
                  <div className="text-gray-400 text-sm text-center">
                    [Logo Placeholder]
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <p className="text-center text-gray-500 mt-8 text-sm">
            Want to become a sponsor or partner? <Link to="/get-involved" className="text-red-600 hover:underline">Get in touch with us</Link>
          </p>
        </div>
      </section>

      {/* Photo Gallery Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-sm font-semibold text-red-600 uppercase tracking-wider mb-3">
              Memories
            </h2>
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Through the Years
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              A look back at the scholars, staff, and moments that have made Mentors in Motion special.
            </p>
          </div>

          {/* Photo Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {photos.map((photo, index) => (
              <div 
                key={index} 
                className="aspect-square bg-gray-100 rounded-xl overflow-hidden hover:scale-105 transition-transform duration-300 shadow-md hover:shadow-xl cursor-pointer"
                onClick={() => setSelectedImageIndex(index)}
              >
                {photo.src ? (
                  <img 
                    src={photo.src} 
                    alt={photo.alt} 
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
                    [Photo Placeholder]
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Image Lightbox Modal with Navigation */}
          {selectedImageIndex !== null && (
            <div 
              className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
              onClick={() => setSelectedImageIndex(null)}
            >
              {/* Close Button - Top Right */}
              <button
                className="absolute top-6 right-6 text-white hover:text-gray-300 transition-colors z-50 bg-black/50 rounded-full p-2"
                onClick={() => setSelectedImageIndex(null)}
              >
                <X className="w-8 h-8" />
              </button>

              {/* Left Arrow */}
              <button
                className="absolute left-4 md:left-8 text-white hover:text-gray-300 transition-colors z-50 bg-black/50 hover:bg-black/70 rounded-full p-3"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImageIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1));
                }}
              >
                <ChevronLeft className="w-8 h-8" />
              </button>

              {/* Image */}
              <img 
                src={photos[selectedImageIndex].src} 
                alt={photos[selectedImageIndex].alt}
                className="max-w-[85vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
                onClick={(e) => e.stopPropagation()}
              />

              {/* Right Arrow */}
              <button
                className="absolute right-4 md:right-8 text-white hover:text-gray-300 transition-colors z-50 bg-black/50 hover:bg-black/70 rounded-full p-3"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImageIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1));
                }}
              >
                <ChevronRight className="w-8 h-8" />
              </button>

              {/* Image Counter */}
              <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 text-white text-sm bg-black/50 px-4 py-2 rounded-full">
                {selectedImageIndex + 1} / {photos.length}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">
            Join Our Family
          </h2>
          <p className="text-xl text-red-100 mb-10">
            Whether through a donation, volunteer hours, or partnership, you can be part of the next chapter in our story.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/donate">
              <Button size="lg" className="bg-white text-red-600 hover:bg-gray-100 font-semibold px-8">
                <Heart className="w-5 h-5 mr-2" />
                Donate Now
              </Button>
            </Link>
            <Link to="/get-involved">
              <Button size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white/10 font-semibold px-8">
                Get Involved
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ThankYou;
